<!-- eslint-disable vue/no-duplicate-attributes -->
<template>
  <div :class="disabled ? 'rex-toggle disabled-toggle disabled' : 'rex-toggle'">
    <label class="toggleSwitch" :class="[classArray]" :style="customStyle">
      <input type="checkbox" :id="`rex-toggle${id}`" :value="checked" />
      <div class="toggle-parent">
        <span
          class="toggle-off"
          :class="[!checked ? 'active-class' : 'inactive-class']"
          @click="checked && clickHandler()"
        >
          <BaseIcon
            :name="iconNames.icon1.name"
            width="1em"
            height="0.8em"
            class="iconSize"
            :iconColor="iconNames.icon1.color"
            v-if="iconNames.isIconEnabled"
          />
          {{ label[0] }}
        </span>
        <span
          class="toggle-on"
          :class="[checked ? 'active-class' : 'inactive-class']"
          @click="!checked && clickHandler()"
        >
          <BaseIcon
            :name="iconNames.icon2.name"
            width="1rem"
            height="0.8em"
            class="iconSize"
            :iconColor="iconNames.icon2.color"
            v-if="iconNames.isIconEnabled"
          />
          {{ label[1] }}
        </span>
      </div>
    </label>
  </div>
</template>

<script>
/**
 * The only true select dropdown .
 * @displayName RexToggle
 */
export default {
  name: 'RexToggle',
  data: function () {
    return {
      checked: false,
      disableOnPage: ['trace', 'profile'],
    };
  },
  props: {
    /**
     * Custom classes for the toggle component
     */
    classArray: { type: Array, default: () => [] },
    /**
     * Array of labels
     * @example
     * ['OFF', 'ON']
     */
    label: {
      type: Array,
      default: () => ['OFF', 'ON'],
    },
    isChecked: { type: Boolean, default: false },
    /**
     * Custom styles to control the properties of the toggle component
     */
    customStyle: {
      type: Object,
      default: () => {
        return {
          width: '9.3125rem',
          height: '1.8rem',
        };
      },
    },
    /** 
       * Names of icons 
       * @example
       * isIconEnabled: true,
       * icon1: 'topoTable',
       * icon2: 'topoMap'
         }
         */
    iconNames: {
      type: Object,
      default: () => {
        return {
          isIconEnabled: false,
        };
      },
    },
    id: {
      type: String,
      required: true,
    },
    updateOnClick: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * Triggered when the toggle is clicked
     * @method clickHandler
     */
    clickHandler() {
      /**
       * Triggered when toggled
       * @property {boolean}
       * @event input
       */
      if (this.updateOnClick) {
        this.checked = !this.checked;
        this.$emit('onChange', this.checked);
      } else {
        this.$emit('onChange', !this.checked);
      }
    },
  },
  watch: {},
  mounted() {
    this.checked = this.isChecked || false;
  },
};
</script>
<style lang="scss">
.rex-toggle {
  display: flex;
  cursor: pointer;
}
.disabled {
  pointer-events: none;
  opacity: 0.4;
}
.disabled-toggle {
  pointer-events: none;
}
.toggleSwitch {
  display: inline-block;
  height: 2.1875rem;
  position: relative;
  overflow: visible;
  width: 5.3125rem;
  margin-bottom: 0px;
}
.toggleSwitch input {
  position: absolute;
  opacity: 0;
  z-index: 5;
}
.toggle-parent {
  display: flex;
  border: 1px solid $color-brand-accent;
  height: 100%;
  border-radius: 0.3rem;
  .toggle-off,
  .toggle-on {
    width: 50%;
    @include flex-center;
  }
  .active-class {
    background-color: $color-brand-accent;
    color: $font-contrast;
    // border-radius: 0.375rem;
    transition: all 100ms ease;
    cursor: default;
  }
  .inactive-class {
    cursor: pointer;
    background-color: transparent;
    color: $color-brand-accent;
  }
  .iconSize {
    margin-right: 0.5rem;
  }
}
</style>
